import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/no_user.png'


const _withScopeId = n => (_pushScopeId("data-v-a6300ac6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-bar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-user-img" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "frame" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "user-img",
      src: _imports_0
    })
  ])
], -1))
const _hoisted_3 = { class: "grid-user-name" }
const _hoisted_4 = { class: "grid-sign-options" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sair", -1))
const _hoisted_6 = { class: "icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.user?.name), 1),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.user)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "button logout",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
          }, [
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-right-from-bracket" })
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}